module.exports = __webpack_public_path__ + "img/smiley_2.f08a8dd1.svg";